import React from "react";
import ModalWrapper from "..";
import { useTranslation } from "react-i18next";
import { XCircle } from "lucide-react";
import { Button } from "../../button";

interface LockAccountModalProps {
  isOpen: boolean;
  onOpenChange: () => void;
}

const LockAccountModal = ({ isOpen, onOpenChange }: LockAccountModalProps) => {
  const { t } = useTranslation();

  return (
    <ModalWrapper
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      contentStyles="md:!max-w-3xl"
    >
      <div className="flex flex-col gap-3 justify-center items-center ">
        <XCircle className="w-16 h-16 text-red-500" />
        <p className="text-lg md:text-2xl font-medium capitalize">
          {t("accountIsLocked")}
        </p>
        <p className="md:text-lg text-center"></p>

        <Button onClick={onOpenChange} className="mt-3">
          {t("ok")}
        </Button>
      </div>
    </ModalWrapper>
  );
};

export default React.memo(LockAccountModal);
